var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kun_loading117_container"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"plate"},[_c('div',{staticClass:"black"},[_c('div',{staticClass:"border"},[_c('div',{staticClass:"white"},[_c('div',{staticClass:"center"})])])])]),_c('div',{staticClass:"player"},[_c('div',{staticClass:"rect"}),_c('div',{staticClass:"circ"})])])])
}]

export { render, staticRenderFns }